<template>

  <div class="stepsMenu mt-4">
    <template v-for="(tab, index) in tabMenu">
      <template v-if="index <= lastActiveStep || index <= currentStep">
        <div :class="'active ' + style(index)" @click="changeStep(index)">{{ tab }}</div>
      </template>
      <template v-else>
        <div>{{ tab }}</div>
      </template>
    </template>
  </div>

</template>

<script>

export default {

  name: "stepsMenu",

  data() {
    return {
    }
  },

  props: {
    tabMenu: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    lastActiveStep: {
      type: Number,
      default: 0
    }
  },

  emits: ['stepChanged'],

  methods: {

    style(index) {
      if (index < this.currentStep) {
        return 'previousStyle'
      }
      else if (index === this.currentStep) {
        return 'currentStyle'
      }
      else {
        return 'nextStyle'
      }
    },

    changeStep(index) {
      this.$emit('stepChanged', index)
    }

  }

}

</script>

<style scoped>

.stepsMenu {
  padding-right: 25px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  /*Lets add the numbers for each link using CSS counters. flag is the name of the counter. to be defined using counter-reset in the parent element of the links*/
  counter-reset: flag;
}

.stepsMenu div {
  width: 100%;
  text-decoration: none;
  font-family: Montserrat-Bold, "Arial", sans-serif;
  outline: none;
  display: block;
  float: left;
  font-size: var(--content-font-size);
  line-height: 40px;
  /*need more margin on the left of links to accomodate the numbers*/
  padding: 0 10px 0 35px;
  background: var(--main-white);
  color: var(--secondary-text-color);
  position: relative;
  border-top: solid 1px rgba(0, 0, 0, 0.2);
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
}
/*since the first link does not have a triangle before it we can reduce the left padding to make it look consistent with other links*/
.stepsMenu div:first-child {
  padding-left: 20px;
}
.stepsMenu div:first-child:before {
  left: 14px;
}

/*adding the arrows for the stepsMenus using rotated pseudo elements*/
.stepsMenu div:after {
  content: '';
  position: absolute;
  top: -1px;
  right: -20px; /*half of square's length*/
  /*same dimension as the line-height of .stepsMenu a */
  width: 42px;
  height: 42px;
  /*as you see the rotated square takes a larger height. which makes it tough to position it properly. So we are going to scale it down so that the diagonals become equal to the line-height of the link. We scale it to 70.7% because if square's:
  length = 1; diagonal = (1^2 + 1^2)^0.5 = 1.414 (pythagoras theorem)
  if diagonal required = 1; length = 1/1.414 = 0.707*/
  transform: scale(0.707) rotate(45deg);
  /*we need to prevent the arrows from getting buried under the next link*/
  z-index: 1;
  /*background same as links but the gradient will be rotated to compensate with the transform applied*/
  background: var(--main-white);
  /*stylish arrow design using box shadow*/
  box-shadow:
    1px -1px 0 0 rgba(0, 0, 0, 0.2);
  /*
    5px - for rounded arrows and
    50px - to prevent hover glitches on the border created using shadows*/
  border-radius: 0;
}
/*we will use the :before element to show numbers*/
.stepsMenu div:before {
  content: counter(flag) ".";
  counter-increment: flag;
  margin-right: 5px;
}

/*hover/active styles*/
.stepsMenu div.active {
  cursor: pointer;
}
.stepsMenu div.active:hover{
  color: var(--main-white);
  background: var(--main-color-hover);
  border-top: solid 1px var(--main-color-hover);
  border-bottom: solid 1px var(--main-color-hover);
}
.stepsMenu div.active:hover:after {
  background: var(--main-color-hover);
  box-shadow:
    2px -2px 0 0 var(--main-white);
}

.stepsMenu div.currentStyle{
  color: var(--main-white);
  background: var(--secondary-color);
  border-top: solid 1px var(--secondary-color);
  border-bottom: solid 1px var(--secondary-color);
}
.stepsMenu div.currentStyle:after {
  background: var(--secondary-color);
  box-shadow:
    2px -2px 0 0 white;
}

.stepsMenu div.previousStyle{
  color: var(--main-white);
  background: var(--main-color);
  border-top: solid 1px var(--main-color);
  border-bottom: solid 1px var(--main-color);
}
.stepsMenu div.previousStyle:after {
  background: var(--main-color);
  box-shadow:
    2px -2px 0 0 white;
}

.stepsMenu div.nextStyle{
  color: var(--main-color);
}


</style>



// WEBPACK FOOTER //
// src/components/b122/stepsMenu.vue